import { render, staticRenderFns } from "./UserAdminDetailPage.vue?vue&type=template&id=7f11d626&scoped=true&lang=pug&"
import script from "./UserAdminDetailPage.vue?vue&type=script&lang=js&"
export * from "./UserAdminDetailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f11d626",
  null
  
)

export default component.exports